import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../../../src/i18n';
import TextField from '../../../../components/Fields/TextField';
import CalendarField from '../../../../components/Fields/CalendarField';
import { dateFormats, TP } from '../../../../constants/consts';
import Title from '../../../../components/Title';
import TimePicker from '../../../../components/Fields/TimePicker';
import TitleBlock from '../../../../components/EditComponents/TitleBlock';
import { createDate } from '../../../../utils/date';

const BookingInfoEditFields = ({
  values,
  classes,
  productionPageField,
  boxOfficePageField,
  bookingDateField,
  bookingTimeField,
  setFieldValue,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <section>
        <Title size="big" style={{ fontWeight: 'bold' }}>
          {t(`${TP}.FN_PRODUCTION_WEBPAGES`)}
        </Title>
        <Grid container spacing={6} className={classes.addFields}>
          {[productionPageField, boxOfficePageField].map(webField => (
            <Grid item md={6} sm={12} xs={12} key={webField.name}>
              <Field
                id={webField.name}
                name={webField.name}
                component={TextField}
                label={t(webField.label)}
                placeholder={t(webField.placeholder)}
              />
            </Grid>
          ))}
        </Grid>
      </section>
      <section className={classes.section}>
        <TitleBlock
          title={`${TP}.FN_TIKET_DATE_AND_TIME`}
          subtitle={`${TP}.FN_EDITSEASON_PICK_NEW_PERFORMANCE_DATE_INFO`}
        />
        <Grid container spacing={6} className={classes.addFields}>
          <Grid item md={6} sm={12} xs={12}>
            <CalendarField
              name={bookingDateField.name}
              onChange={day =>
                setFieldValue(bookingDateField.name, day ? createDate(day).format(dateFormats.basic) : '')
              }
              selectedDay={values[bookingDateField.name]}
              label={t(bookingDateField.label)}
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <Field
              id={bookingTimeField.name}
              name={bookingTimeField.name}
              component={TimePicker}
              label={t(bookingTimeField.label)}
              t={t}
              onTimeChange={time => setFieldValue(bookingTimeField.name, time)}
            />
          </Grid>
        </Grid>
      </section>
    </>
  );
};

BookingInfoEditFields.propTypes = {
  values: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  productionPageField: PropTypes.object.isRequired,
  boxOfficePageField: PropTypes.object.isRequired,
  bookingDateField: PropTypes.object.isRequired,
  bookingTimeField: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default memo(BookingInfoEditFields);
